import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../GlobalContext'
import RedAlert from '../../ui-elements/RedAlert'
import Button from '../../formfields/Button'
import AddButton from '../../formfields/AddButton'
import XButton from '../../formfields/XButton'
import Card from '../../ui-elements/Card'


type Props = {
    questionsFormFields: ObjectStringKeyAnyValue
    thisChecklist: ObjectStringKeyAnyValue | null
    questionsFormErrors: ObjectStringKeyAnyValue
    setQuestionsFormFields: React.Dispatch<React.SetStateAction<any>>
}

type SingleOptionProps = {
    optionId: string
    deleteItem: (optionId: string) => void
    optionValues: ObjectStringKeyAnyValue
    questionsFormErrors: ObjectStringKeyAnyValue
    setOption: AnyFunction,
    questionsFormFields: ObjectStringKeyAnyValue
}

function SingleOption({
    optionId,
    deleteItem,
    optionValues,
    questionsFormErrors,
    setOption,
    questionsFormFields
}: SingleOptionProps) {

    const questionFormats: ObjectStringKeyAnyValue = {
        "Date": { "displayName": "Date" },
        "DateAndTime": { "displayName": "Date and time" },
        "Number": { "displayName": "Number" },
        "Text": { "displayName": "Text" },
        "Time": { "displayName": "Time" },
        "YesOrNo": { "displayName": "Yes or No" },
    }

    const formFieldsForThisOption = questionsFormFields['MultiFieldQuestionOptions'][optionId]


    return <Card fullwidth={true}>

        <div className={`absolute top-0 right-0 z-10 p-1`}><XButton
            clickFunction={() => deleteItem(optionId)}
        /></div>

        <div className={`w-full flex flex-row gap-2 pr-5`}>



            <div className={`w-full flex flex-col gap-1`}>
                <p className={``}>Field format:</p>
                <select
                    className={`w-full bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 text-sm px-3 py-2`}

                    name={`QuestionFormat`}
                    value={formFieldsForThisOption['QuestionFormat'] || ''}
                    onChange={(e) => setOption(optionId, 'QuestionFormat', e.target.value)}

                >
                    <option value={``}>Please select</option>

                    {questionFormats && Object.keys(questionFormats).map((formatId, index) => {
                        return <option key={index} value={formatId}>{questionFormats[formatId].displayName}</option>
                    })}

                </select>
            </div>

            <div className={`w-full flex flex-col gap-1`}>
                <p className={``}>Field text:</p>
                <input
                    className={`w-full bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 text-sm px-3 py-2`}
                    type='text'
                    name={`QuestionText`}
                    value={formFieldsForThisOption['QuestionText'] || ''}
                    onChange={(e) => setOption(optionId, 'QuestionText', e.target.value)}

                />
            </div>



        </div>
        {questionsFormErrors[`MultiFieldQuestionOptions-${optionId}`] && <RedAlert alignment='left'>{questionsFormErrors[`MultiFieldQuestionOptions-${optionId}`]}</RedAlert>}
    </Card>
}



function QuestionMultiFieldQuestionOptions({
    questionsFormFields,
    thisChecklist,
    questionsFormErrors,
    setQuestionsFormFields
}: Props) {

    const {
        tableData,
        currentOrganisation,
        sendMessageToWebsocket,
    } = useContext(GlobalContext)

    useEffect(() => {
        // add at least one blank field if there are none
        if (!questionsFormFields['MultiFieldQuestionOptions'] || Object.keys(questionsFormFields['MultiFieldQuestionOptions']).length === 0) {
            addOption()
        }
    }, [questionsFormFields])


    const addOption = () => {
        const newQuestionsFormFields = { ...questionsFormFields }
        const blankOptionId = `op-${Date.now()}-${Math.floor(Math.random() * 1000)}`
        const blankOption = {
            "QuestionText": '',
            "QuestionFormat": '',
        }
        newQuestionsFormFields['MultiFieldQuestionOptions'] = {
            ...newQuestionsFormFields['MultiFieldQuestionOptions'],
            [blankOptionId]: blankOption
        }
        setQuestionsFormFields(newQuestionsFormFields)
    }

    const deleteOption = (optionId: string) => {
        const newQuestionsFormFields = { ...questionsFormFields }
        delete newQuestionsFormFields['MultiFieldQuestionOptions'][optionId]
        setQuestionsFormFields(newQuestionsFormFields)
    }



    const setOption = (optionId: string, key: string, value: string) => {
        const newQuestionsFormFields = { ...questionsFormFields }
        if (!newQuestionsFormFields['MultiFieldQuestionOptions']) {
            newQuestionsFormFields['MultiFieldQuestionOptions'] = {}
        }
        if (!newQuestionsFormFields['MultiFieldQuestionOptions'][optionId]) {
            newQuestionsFormFields['MultiFieldQuestionOptions'][optionId] = {}
        }
        if (value) {
            newQuestionsFormFields['MultiFieldQuestionOptions'][optionId][key] = value
        } else {
            delete newQuestionsFormFields['MultiFieldQuestionOptions'][optionId][key]
        }
        setQuestionsFormFields(newQuestionsFormFields)
    }



    return <div className={`flex flex-col gap-2`}>

        <div className={`flex flex-row gap-2`}>
            <h3 className={`font-righteous text-brandblue text-lg`}>
                Fields:
            </h3>
        </div>

        {
            questionsFormFields &&
            questionsFormFields['MultiFieldQuestionOptions'] &&
            Object.keys(questionsFormFields['MultiFieldQuestionOptions']).length > 0 &&
            <div className={`flex flex-row flex-wrap gap-2`}>
                {Object.keys(questionsFormFields['MultiFieldQuestionOptions']).map((optionId: string, index: number) => {
                    const optionValues = questionsFormFields['MultiFieldQuestionOptions'][optionId]
                    return <SingleOption
                        key={index}
                        optionId={optionId}
                        optionValues={optionValues}
                        deleteItem={() => deleteOption(optionId)}
                        questionsFormErrors={questionsFormErrors}
                        setOption={setOption}
                        questionsFormFields={questionsFormFields}
                    />
                })}
            </div>
        }
        <AddButton
            text={'Add more fields'}
            onClick={addOption}
        />

        {questionsFormErrors['MultiFieldQuestionOptions'] && <RedAlert alignment='left'>{questionsFormErrors['MultiFieldQuestionOptions']}</RedAlert>}

    </div>
}



export default QuestionMultiFieldQuestionOptions